import { GlobalState } from './types';
import ActionTypes from './constants';

let initCartCount = 0;
const localCartCount = localStorage.getItem('CartCount');
if (localCartCount !== null){
    initCartCount = +localCartCount;
}

export const initialState: GlobalState = {
    currentPage: 'home',
    cartCount: initCartCount,
    addToCartSuccess: false,

    isAuthenticated: false,
    user: null
};

function globalReducer(
    state: GlobalState = initialState,
    action: any
) {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload
            }

        case ActionTypes.ADD_PRODUCT_TO_CART:
            localStorage.setItem('CartCount', (state.cartCount + 1).toString());
            return {
                ...state,
                addToCartSuccess: true,
                cartCount: state.cartCount + 1
            }

        case ActionTypes.ADD_PRODUCT_TO_CART_COMPLETED:
            return {
                ...state,
                addToCartSuccess: false
            }

        case ActionTypes.REMOVE_PRODUCT_FROM_CART:
            if (state.cartCount > 0){
                localStorage.setItem('CartCount', (state.cartCount - 1).toString());
                return {
                    ...state,
                    cartCount: state.cartCount - 1
                }
            }
            else {
                return state;
            }

        case ActionTypes.CLEAR_CART:
            localStorage.removeItem('CartCount');
            return {
                ...state,
                cartCount: 0
            }

        case ActionTypes.SET_CART_ITEM_COUNT:
            localStorage.setItem('CartCount', action.payload.toString());
            return {
                ...state,
                cartCount: action.payload
            }

        case ActionTypes.SET_USER_AUTHENTICATED:
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload
            };

        
        default:
            return state;
    }
}

export default globalReducer;